export default __webpack_public_path__ + "static/media/iread_22_8.5faf0315.jpg";